import Cookies from 'js-cookie'

const showBackToRegistryLink = () => {
	var userInfoValue = Cookies.get("userInfo");
	if(userInfoValue){
		var parseUserInfoCookie = JSON.parse(userInfoValue);
		var countryCookie = Cookies.get('zCountry');
		var df = "DefaultRegistry";
		var registryNum = parseUserInfoCookie[df];
	    if (registryNum !== undefined && countryCookie == 'US' && $('#registry')) {
	    	$('#registry').find('a').attr('href', "/webapp/wcs/stores/servlet/RegistryManageProducts?catalogId=301&langId=-1&storeId=301&actionCode=M&registryNumber=" + registryNum);
	    	$('#registry').show();
	    }
	}
};

export {showBackToRegistryLink}
